import type { CompEvent, IndividualEntry } from '@/components/results/store-comp-results'
import type { SocketResultMessagePayloadEntriesPresent } from '@/components/results/socket/entries-present/models/entries-present'
import { simpleClone } from '@/services/common-service-utils'

export function updateEntriesPresent(
  compEvent: CompEvent,
  payload: SocketResultMessagePayloadEntriesPresent
): CompEvent {
  const compEventInternal = simpleClone(compEvent)

  if (!compEventInternal.entries) {
    return compEventInternal
  }

  // loop thru all the compEventInternal.entries and update the present flag
  Object.values(compEventInternal.entries).forEach((entry: IndividualEntry) => {
    // if entry ID is in the payload.entryIds then update the present flag
    if (payload.entryIds.includes(entry.entryId)) {
      entry.present = payload.present === 1 ? 1 : null
      return
    }
  })

  return compEventInternal
}
